// HeroSection.jsx
import React from "react";

import equipment2 from "src/components/ui/images/equipment2.jpeg";
import logomain from "src/components/ui/images/logowhitemain.png"
const HeroSection = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen bg-black flex items-center justify-center"
      style={{
        backgroundImage:
          `url(${equipment2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/80" />

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="max-w-6xl mx-auto px-4 text-center">
          {/* Add padding-top so content clears a fixed header on mobile too */}
          <div className="pt-24 sm:pt-28 md:pt-28" />

          {/* Logo */}
          <div className="flex items-center justify-center mb-10 sm:mb-12">
            <img
              src={logomain}
              alt="Clara Boxing Academy Logo"
              className="w-32 h-32 md:w-48 md:h-48 lg:w-56 lg:h-56 rounded-full border-4 border-white shadow-lg object-cover"
            />
          </div>

          {/* Headline */}
          <div className="mb-8">
            <p className="text-red-600 text-sm sm:text-base md:text-xl font-semibold uppercase tracking-widest mb-3 sm:mb-4">
              A Boxing Academy open to all levels of boxing.
            </p>
            <h1 className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-bold uppercase leading-tight mb-6 sm:mb-8">
              Chicago&apos;s #1 Boxing
              <br />
              <span className="text-transparent bg-gradient-to-r from-red-600 to-red-400 bg-clip-text">
                Academy
              </span>
            </h1>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
            <button
              onClick={() =>
                document
                  .querySelector("#contactform")
                  ?.scrollIntoView({ behavior: "smooth", block: "start" })
              }
              className="bg-red-600 hover:bg-red-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold uppercase tracking-wide transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-red-600/25"
            >
              Start Your Journey
            </button>
         
          </div>

          {/* Badges */}
          <div className="mt-12 sm:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 text-white">
            <div className="text-center">
              <h3 className="text-xl sm:text-2xl font-bold text-red-600 mb-1 sm:mb-2">
                3 Days FREE
              </h3>
              <p className="text-gray-300 text-sm sm:text-base">Trial Available</p>
            </div>
            <div className="text-center">
              <h3 className="text-xl sm:text-2xl font-bold text-red-600 mb-1 sm:mb-2">
                No Contracts
              </h3>
              <p className="text-gray-300 text-sm sm:text-base">Month-to-Month</p>
            </div>
            <div className="text-center">
              <h3 className="text-xl sm:text-2xl font-bold text-red-600 mb-1 sm:mb-2">
                All Levels
              </h3>
              <p className="text-gray-300 text-sm sm:text-base">Welcome Here</p>
            </div>
          </div>

          {/* Optional: anchor offset so #home links don't land under the header */}
          <div className="pb-10 sm:pb-12" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
